import { Input } from "antd";
import Typography from "@mui/material/Typography";
import { SearchOutlined } from "@ant-design/icons";


/**
 * Generic table search bar.
 * 
 * @param {*} props 
 * @prop {Array.Object} originalTableData super set of all displayed table objects
 * @prop {callable} updateTableState state setter for displayed table data (subset of originalTableData)
 * @prop {boolean} isLoading loading state of the table being searched
 * @prop {Array.Array.string} searchKeys keys in originalTableData objects to apply search text to
 */
function SearchBar(props) {

  const getNestedValue = (obj, keys) => {
    return keys.reduce((acc, key) => {
      return acc && acc[key] !== undefined ? acc[key] : undefined;
    }, obj);
  };

  const handleSearch = (e) => {
    const searchText = e.target.value;
    if (props.setSearchText) props.setSearchText(searchText); // optional tracking

    if (searchText === "") {
      // Reset search: show full filtered or full data
      props.updateTableState(props.originalTableData);
    } else {
      const resData = props.originalTableData.filter((row) =>
        props.searchKeys.some((keyPath) => {
          const value = getNestedValue(row, keyPath);
          return typeof value === "string" && value.toLowerCase().includes(searchText.toLowerCase());
        })
      );
      props.updateTableState(resData);
    }
  };

  return (
    <Input
      // disabled={props.originalTableData.length === 0 || props.isLoading}
      placeholder="Search"
      prefix={<SearchOutlined />}
      suffix={
        <Typography variant="subtitle1" sx={{ color: "lightgrey" }}>
          Please enter to search
        </Typography>
      }
      onKeyPress={(e) => {
        if (e.key === 'Enter') {
          if (props.setSearchText) props.setSearchText(e.target.value);
          handleSearch(e);
        }
      }}
    />
  );
}

export default SearchBar;